/* StrateLab V3 – couche de mouvement */
(function(){
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FINE = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var d = document, root = d.documentElement;
  root.classList.add('v3');
  if (RM) { root.classList.add('v3-rm'); return; }

  /* 1. Rideau d'ouverture (une fois par visite) */
  function curtain(){
    var seen = false; try { seen = sessionStorage.getItem('v3-intro') === '1'; sessionStorage.setItem('v3-intro','1'); } catch(e){}
    if (seen || !d.querySelector('.slh-hero')) return;
    var c = d.createElement('div'); c.className = 'v3-curtain'; c.setAttribute('aria-hidden','true');
    c.innerHTML = '<svg viewBox="0 0 120 70" class="v3-curtain__logo"><path class="l1" d="M10 18c20-10 40 10 60 0s30-8 40-2v10c-10-6-20-8-40 2s-40-10-60 0z"/><path class="l2" d="M10 38c20-10 40 10 60 0s30-8 40-2v10c-10-6-20-8-40 2s-40-10-60 0z"/><path class="l3" d="M10 58c20-10 40 10 60 0s30-8 40-2v10c-10-6-20-8-40 2s-40-10-60 0z"/></svg>';
    d.body.appendChild(c);
    root.classList.add('v3-intro');
    setTimeout(function(){ c.classList.add('is-out'); root.classList.remove('v3-intro'); }, 1150);
    setTimeout(function(){ c.remove(); }, 2100);
  }

  /* 2. Barre de progression */
  function progress(){
    var b = d.createElement('div'); b.className = 'v3-progress'; b.setAttribute('aria-hidden','true'); d.body.appendChild(b);
    return b;
  }

  /* 3. Découpe des titres en mots pour l'apparition */
  function split(el){
    if (el.dataset.v3split) return; el.dataset.v3split = '1';
    var walker = d.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), nodes = [], n, i = 0;
    while ((n = walker.nextNode())) nodes.push(n);
    nodes.forEach(function(t){
      var parts = t.nodeValue.split(/(\s+)/), frag = d.createDocumentFragment();
      parts.forEach(function(p){
        if (!p) return;
        if (/^\s+$/.test(p)) { frag.appendChild(d.createTextNode(p)); return; }
        var w = d.createElement('span'); w.className = 'v3-w';
        var inner = d.createElement('span'); inner.className = 'v3-wi'; inner.textContent = p; inner.style.setProperty('--i', i++);
        w.appendChild(inner); frag.appendChild(w);
      });
      t.parentNode.replaceChild(frag, t);
    });
    el.classList.add('v3-split');
  }

  /* 4. Bandeaux croisés */
  function marquees(){
    d.querySelectorAll('.slh-marquee').forEach(function(m){
      if (m.dataset.v3) return; m.dataset.v3 = '1';
      var wrap = d.createElement('div'); wrap.className = 'v3-cross';
      m.parentNode.insertBefore(wrap, m); wrap.appendChild(m);
      var clone = m.cloneNode(true); clone.classList.add('slh-marquee--alt'); clone.setAttribute('aria-hidden','true'); clone.removeAttribute('aria-label');
      wrap.insertBefore(clone, m);
    });
  }

  /* 5. Inclinaison 3D + reflet */
  function tilt(sel, max){
    if (!FINE) return;
    d.querySelectorAll(sel).forEach(function(el){
      if (el.dataset.v3tilt) return; el.dataset.v3tilt = '1'; el.classList.add('v3-tilt');
      var glare = d.createElement('span'); glare.className = 'v3-glare'; glare.setAttribute('aria-hidden','true'); el.appendChild(glare);
      el.addEventListener('pointermove', function(e){
        var r = el.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
        el.style.setProperty('--rx', ((0.5 - y) * max).toFixed(2) + 'deg');
        el.style.setProperty('--ry', ((x - 0.5) * max).toFixed(2) + 'deg');
        el.style.setProperty('--gx', (x * 100).toFixed(1) + '%');
        el.style.setProperty('--gy', (y * 100).toFixed(1) + '%');
      });
      el.addEventListener('pointerleave', function(){ el.style.setProperty('--rx','0deg'); el.style.setProperty('--ry','0deg'); });
    });
  }

  /* 6. Boutons magnétiques */
  function magnetic(){
    if (!FINE) return;
    d.querySelectorAll('.slh-btn, .slh-bento__label b, .slh-card__cta').forEach(function(b){
      if (b.dataset.v3mag) return; b.dataset.v3mag = '1';
      var host = b.closest('.slh-btn') ? b : (b.closest('a') || b);
      host.addEventListener('pointermove', function(e){
        var r = b.getBoundingClientRect(), x = e.clientX - (r.left + r.width/2), y = e.clientY - (r.top + r.height/2);
        b.style.transform = 'translate(' + (x * 0.25).toFixed(1) + 'px,' + (y * 0.3).toFixed(1) + 'px)';
      });
      host.addEventListener('pointerleave', function(){ b.style.transform = ''; });
    });
  }

  /* 7. Curseur personnalisé */
  function cursor(){
    if (!FINE) return;
    var dot = d.createElement('div'), ring = d.createElement('div');
    dot.className = 'v3-cur v3-cur--dot'; ring.className = 'v3-cur v3-cur--ring';
    ring.innerHTML = '<span>→</span>';
    [dot, ring].forEach(function(e){ e.setAttribute('aria-hidden','true'); d.body.appendChild(e); });
    var mx = -100, my = -100, rx = -100, ry = -100;
    window.addEventListener('pointermove', function(e){ mx = e.clientX; my = e.clientY; root.classList.add('v3-cur-on'); }, {passive:true});
    d.addEventListener('pointerleave', function(){ root.classList.remove('v3-cur-on'); });
    d.addEventListener('pointerover', function(e){
      var t = e.target.closest ? e.target : null; if (!t) return;
      root.classList.toggle('v3-cur-media', !!t.closest('.slh-card__media, .slh-bento__item, .slh-hero__tile, .slh-story__media'));
      root.classList.toggle('v3-cur-link', !!t.closest('a, button, summary, input, select, label'));
    });
    (function loop(){ rx += (mx - rx) * 0.18; ry += (my - ry) * 0.18;
      dot.style.transform = 'translate(' + mx + 'px,' + my + 'px)';
      ring.style.transform = 'translate(' + rx + 'px,' + ry + 'px)';
      requestAnimationFrame(loop); })();
  }

  /* 8. Défilement : parallaxe, vitesse des bandeaux, progression */
  var bar, lastY = window.scrollY, vel = 0, mqOffset = 0, ticking = false;
  function onFrame(){
    ticking = false;
    var y = window.scrollY, h = window.innerHeight, docH = root.scrollHeight - h;
    vel = vel * 0.85 + (y - lastY) * 0.15; lastY = y;
    if (bar) bar.style.transform = 'scaleX(' + (docH > 0 ? y / docH : 0).toFixed(4) + ')';
    d.querySelectorAll('[data-v3-par]').forEach(function(el){
      var r = el.getBoundingClientRect(); if (r.bottom < -100 || r.top > h + 100) return;
      var p = (r.top + r.height/2 - h/2) / h, k = parseFloat(el.dataset.v3Par) || 40;
      el.style.setProperty('--par', (p * -k).toFixed(1) + 'px');
    });
    var hero = d.querySelector('.slh-hero');
    if (hero) { var hr = hero.getBoundingClientRect(); hero.style.setProperty('--hp', Math.min(Math.max(-hr.top / hr.height, 0), 1).toFixed(3)); }
  }
  function req(){ if (!ticking) { ticking = true; requestAnimationFrame(onFrame); } }
  (function mqLoop(){
    mqOffset += 0.6 + Math.min(Math.abs(vel), 40) * 0.35;
    d.querySelectorAll('.v3-cross .slh-marquee__track').forEach(function(t, i){
      var w = t.scrollWidth / 4; if (!w) return;
      var o = (mqOffset % w);
      t.style.transform = 'translate3d(' + (i % 2 ? -(w - o) : -o).toFixed(1) + 'px,0,0)';
    });
    vel *= 0.95;
    requestAnimationFrame(mqLoop);
  })();

  /* 9. Souris sur la bannière : profondeur */
  function heroDepth(){
    var hero = d.querySelector('.slh-hero'); if (!hero || !FINE) return;
    hero.addEventListener('pointermove', function(e){
      var r = hero.getBoundingClientRect();
      hero.style.setProperty('--mx', ((e.clientX - r.left) / r.width - 0.5).toFixed(3));
      hero.style.setProperty('--my', ((e.clientY - r.top) / r.height - 0.5).toFixed(3));
    });
  }

  /* 10. Strates animées dans la bannière */
  function strata(){
    var hero = d.querySelector('.slh-hero'); if (!hero || hero.querySelector('.v3-strata')) return;
    var s = d.createElement('div'); s.className = 'v3-strata'; s.setAttribute('aria-hidden','true');
    var paths = '';
    for (var k = 0; k < 7; k++) {
      var y = 40 + k * 52;
      paths += '<path style="--k:' + k + '" d="M-200 ' + y + ' C 0 ' + (y - 46) + ', 200 ' + (y + 46) + ', 400 ' + y + ' S 800 ' + (y - 46) + ', 1000 ' + y + ' S 1400 ' + (y + 46) + ', 1600 ' + y + ' S 2000 ' + (y - 46) + ', 2200 ' + y + '"/>';
    }
    s.innerHTML = '<svg viewBox="0 0 1600 420" preserveAspectRatio="none">' + paths + '</svg>';
    hero.insertBefore(s, hero.firstChild);
  }

  function init(){
    if (!bar) bar = progress();
    strata(); heroDepth();
    d.querySelectorAll('.slh-hero__title, .slh .slh-h2').forEach(split);
    marquees();
    tilt('.slh-card__media', 10); tilt('.slh-feature', 6); tilt('.slh-hero__tile', 8);
    magnetic();
    d.querySelectorAll('.slh-story__media, .slh-faq__media').forEach(function(el){ el.dataset.v3Par = el.dataset.v3Par || '60'; });
    d.querySelectorAll('.slh-hero__tile').forEach(function(el, i){ el.dataset.v3Par = String([24, 56, 56][i] || 40); });
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting) { e.target.classList.add('v3-in'); io.unobserve(e.target); } }); }, { threshold: 0.2 }) : null;
    d.querySelectorAll('.v3-split, .slh-story__num, .slh-feature__icon').forEach(function(el){ io ? io.observe(el) : el.classList.add('v3-in'); });
    setTimeout(function(){ d.querySelectorAll('.v3-split, .slh-story__num').forEach(function(el){ el.classList.add('v3-in'); }); }, 7000);
    onFrame();
  }
  window.addEventListener('scroll', req, { passive: true });
  window.addEventListener('resize', req);
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function(){ curtain(); init(); cursor(); }); else { curtain(); init(); cursor(); }
  d.addEventListener('shopify:section:load', init);
})();